<template>
  <SectionTemplate
    title="你想要的专业级视频效果 AI几秒就能搞定"
    sub-title="专业级视频生成"
    :desc="`舞台、灯光，角色、拍摄、剪辑、后期...传统视频制作的的每一个复杂环节，现在交给AI就能搞定。\n无需专业设备与技巧，人人能轻松做出媲美专业团队的视频效果。`"
    class="ai-pro-effects"
    headerSpacing="40px"
  >
    <div class="ai-pro-effects__container">
      <VideoPlayer
        class="ai-pro-effects__video"
        :autoplay="true"
        :muted="isMuted"
        :enable-fullscreen="false"
        :poster-transform="undefined"
        :poster="
          getFeUrl(
            '/youyan-platform/ai-avatar-video-generation/pro-effects/cover.jpg?x-oss-process=image/format,webp',
          )
        "
        :url="getFeUrl('/youyan-platform/ai-avatar-video-generation/pro-effects/pro-effect.m3u8')"
        title="无需拍摄剪辑，只需输入文字，使用有言即可一键生成高质量3D数字人视频"
      />
      <div class="ai-pro-effects__content">
        <div class="ai-pro-effects__detail">
          <div class="ai-pro-effects__detail-title">
            <p>短视频、长演讲</p>
            <p>任意时长、妙级生成</p>
          </div>
          <p class="ai-pro-effects__detail-desc">
            无论是30秒的短视频，还是60分钟的专业讲座，有言都能快速生成。3D数字人表达自然生动，配合专业镜头调度，即使视频再长，也能清晰传递信息，持续吸引观众。
          </p>
        </div>
        <div class="ai-pro-effects__detail">
          <div class="ai-pro-effects__detail-title">
            <p>海量角色、场景、镜头自由搭配</p>
            <p>轻松搞定各类视频需求</p>
          </div>
          <p class="ai-pro-effects__detail-desc">
            3000+可编辑、超写实3D数字人形象、近千款高质量3D场景，还有不同音色、动作风格和镜头组合任你搭配。无论是企业培训、社媒运营还是活动主持视频，有言轻松适配，一站式满足多场景视频需求。
          </p>
        </div>
      </div>
    </div>
    <TrailBtn />
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import VideoPlayer from '~/components/video-player/index.vue';
import TrailBtn from '../../components/trail-btn.vue';
const isMuted = inject<boolean>('isMuted') || true;
</script>

<style lang="scss" scoped src="./mobile.scss"></style>
<style lang="scss" scoped src="./pc.scss" />
